import { Box, Card, CardActionArea, CardContent, CardMedia, Stack, useTheme } from "@mui/material";
import { FC } from "react";
import { getPublicAlbumImageUrl } from "../utils/fileUtils";
import Album from "../models/album";
import { formatDate } from "../utils/formatUtils";
import useQuickFilterPortal from "../hooks/useQuickFilterPortal";
import { useNavigate } from "react-router-dom";

type Props = {
	album: Album;
};

const AlbumTile: FC<Props> = ({ album }) => {
	const theme = useTheme();
	const quickFilter = useQuickFilterPortal();
	const navigate = useNavigate();

	const handleAlbumClick = () => {
		quickFilter.setFilterText(album.name);
		navigate({ pathname: '/tunes', search: `?q=${album.name}` });
	};

	return (
		<Card sx={{ width: 350 }}>
			<CardActionArea className="slow-zoom-out-hover" onClick={handleAlbumClick}>
				<CardMedia component="div">
					<Box
						component="img"
						height={350}
						src={getPublicAlbumImageUrl(album)}
						alt={album.name}
					/>
				</CardMedia>
				<CardContent>
					<Stack spacing={1}>
						<Box sx={{ fontFamily: theme.typography.fontFamily, fontSize: '1.25rem', fontWeight: 600, color: theme.palette.text.primary }}>{album.name}</Box>
						<Stack direction="row" spacing={2} sx={{ justifyContent: 'space-between', alignItems: 'baseline' }}>
							<Box sx={{ fontFamily: theme.typography.fontFamily, fontSize: '1rem', color: theme.palette.text.secondary }}>Tim Kulig</Box>
							<Box sx={{ fontFamily: theme.typography.fontFamily, fontSize: '0.875rem', color: theme.palette.text.secondary }}>Released {formatDate(album.releaseDate, 'MMM D, YYYY')}</Box>
						</Stack>
					</Stack>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

export default AlbumTile;
